export enum ErrorType {
  NotFound = 404,
  PaymentRequired = 402,
  Forbidden = 403,
  InternalServerError = 500,
  NotImplemented = 501,
  Blocked = 701,
}
